import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const profileRouteRef = createRouteRef({
  params: ['profileName'],
});
export const agentRouteRef = createRouteRef({
  params: ['profileName', 'agentName'],
});

export function profilesPath(): string {
  return '/agent-registry';
}

export function profilePath(profileName: string): string {
  return `/agent-registry/profiles/${encodeURIComponent(profileName)}`;
}

export function profileAgentsPath(profileName: string): string {
  return `${profilePath(profileName)}/agents`;
}

export function agentPath(profileName: string, agentName: string): string {
  return `${profileAgentsPath(profileName)}/${encodeURIComponent(agentName)}`;
}
